import { PaymentSection } from './PaymentSection';

export default PaymentSection;
